module.exports = __webpack_public_path__ + "img/default-browse-vehicles-images-mazda.6b202e57.png";